import React from "react";
import SongEditor from "./SongEditor";

export default function AddSongV2() {
  return <SongEditor mode="create" />;
}
